export default "__VITE_ASSET__DNzpMY3Q__"